import { Flex } from '@chakra-ui/react';
import { Text, Tooltip, TooltipPlacement } from '../../ui-components';
import { useCustomPreferences } from '../../utils/api';
import { CustomPreference } from '../../utils/api/CustomPreference';
import { GetIcon } from '../icons';

export const InformationMessage = () => {
    const preferences = useCustomPreferences([
        CustomPreference.INFORMATION_MESSAGE_CART_AND_CHECKOUT_LINE_1,
        CustomPreference.INFORMATION_MESSAGE_CART_AND_CHECKOUT_LINE_2,
        CustomPreference.INFORMATION_MESSAGE_CART_AND_CHECKOUT_TOOLTIP,
    ]);

    return (
        <Flex
            data-testid="information-message-wrapper"
            background="white"
            gap={0.5}
            direction="column"
        >
            <Flex alignItems="center" gap={1}>
                <Text size="small">
                    {preferences[CustomPreference.INFORMATION_MESSAGE_CART_AND_CHECKOUT_LINE_1]}
                </Text>
                <Tooltip
                    label={
                        preferences[CustomPreference.INFORMATION_MESSAGE_CART_AND_CHECKOUT_TOOLTIP]
                    }
                    placement={TooltipPlacement.top}
                >
                    <Flex alignItems="center">
                        <GetIcon name="info" size="sm" />
                    </Flex>
                </Tooltip>
            </Flex>
            <Text size="small">
                {preferences[CustomPreference.INFORMATION_MESSAGE_CART_AND_CHECKOUT_LINE_2]}
            </Text>
        </Flex>
    );
};
